import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { CoachProductAutomationRunsPage } from "src/pages/CoachProductAutomationRunsPage";
import {
  AUTOMATION_RUNS_PAGE_SIZE,
  automationRunsQueryOptions,
} from "src/queries/automations";

const routeSearchSchema = z.object({
  p: z.number().int().min(0).optional(),
});

export const Route = createFileRoute(
  "/_auth/_coach/products/$productId/automations/$automationId/runs",
)({
  component: CoachProductAutomationRunsPage,
  validateSearch: routeSearchSchema,
  ssr: true,
  loaderDeps: ({ search }) => {
    return { pageIndex: search.p ?? 0 };
  },
  async loader({ context, params, deps }) {
    return context.queryClient.query({
      ...automationRunsQueryOptions(
        params.automationId,
        deps.pageIndex,
        AUTOMATION_RUNS_PAGE_SIZE,
      ),
      staleTime: "static",
    });
  },
});
